import React from 'react';
import Helmet from 'react-helmet';

const FontawesomePixel = () => (
  <Helmet>
    <script src="https://kit.fontawesome.com/61e25beff6.js" crossOrigin="anonymous"></script>
  </Helmet>
);
export default FontawesomePixel;
